import { render, staticRenderFns } from "./player-box.vue?vue&type=template&id=0c08190e&scoped=true&"
import script from "./player-box.vue?vue&type=script&lang=js&"
export * from "./player-box.vue?vue&type=script&lang=js&"
import style0 from "./player-box.vue?vue&type=style&index=0&id=0c08190e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08190e",
  null
  
)

export default component.exports